module.exports = __webpack_public_path__ + "img/header-diamondJewelry100Carat.9f6fffa.jpg";